import type { ReceiptTemplate } from '../schema';

export const starbucksTemplate: ReceiptTemplate = {
  id: 'starbucks',
  name: 'Starbucks Receipt',
  brand: 'Starbucks',
  description: 'Coffee shop receipt template inspired by Starbucks',
  settings: {
    width: 260,
    font: 'Courier New',
    fontSize: 10,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1e3932',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
  },
  sections: [
    {
      id: 'sbux-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/starbucks.png',
        logoData: '',
        logoWidth: 60,
        logoHeight: 60,
        businessName: '',
        businessNameFontSize: 18,
        addressLines: [
          'Starbucks Coffee',
          '1585 Broadway',
          'New York, NY 10036',
          'Store #12847',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'sbux-datetime',
      type: 'datetime',
      enabled: true,
      config: {
        alignment: 'center',
        dateTime: '09/30/2025 08:23 AM',
        format: 'MM/DD/YYYY hh:mm A',
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'sbux-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        showQuantity: true,
        quantityPosition: 'left',
        showHeader: false,
        showHeaderDivider: false,
        headerLabels: {
          quantity: 'Qty',
          item: 'Item',
          amount: 'Price',
        },
        items: [
          { id: 'sbux-item-1', quantity: '1', name: 'Venti Caramel Macchiato', price: '$6.45' },
          { id: 'sbux-item-2', quantity: '1', name: 'Bacon & Gouda Sandwich', price: '$5.75' },
          { id: 'sbux-item-3', quantity: '1', name: 'Butter Croissant', price: '$3.95' },
        ],
        showTopDivider: false,
        showDivider: false,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'sbux-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'left',
        labelPosition: 50,
        lines: [
          { id: 'sbux-subtotal', label: 'Subtotal', value: '16.15', isBold: false, isLarge: false },
          { id: 'sbux-tax', label: 'Tax', value: '1.43', isBold: false, isLarge: false },
          { id: 'sbux-total', label: 'Total', value: '17.58', isBold: true, isLarge: true },
        ],
        increaseTotalSize: true,
        totalSizeIncrease: 20,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'sbux-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        paymentType: 'card',
        cardFields: [
          { id: 'sbux-card', label: 'Starbucks Card', value: '****5847' },
          { id: 'sbux-balance', label: 'Remaining Balance', value: '$32.42' },
        ],
        cashFields: [
          { id: 'sbux-cash', label: 'Cash', value: '$20.00' },
          { id: 'sbux-change', label: 'Change', value: '$2.42' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'sbux-rewards',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: '★ STARBUCKS REWARDS ★\nStars Earned: 35\nTotal Stars: 287\n\n38 stars until Gold Status!',
        fontSize: 10,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'sbux-message',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'Tell us about your visit!\nstarbucks.com/survey\nCode: SB-2847-9301\n\nThank you!',
        fontSize: 9,
        showDivider: false,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'sbux-barcode',
      type: 'barcode',
      enabled: true,
      config: {
        alignment: 'center',
        type: 'code128',
        value: 'SB28479301',
        showValue: false,
        width: 1.3,
        height: 35,
        showDivider: false,
        dividerStyle: 'dashed',
      },
    },
  ],
};
